module.exports = __webpack_public_path__ + "img/advanced7.c05b395b.png";